var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('BaseTitle', {
    staticClass: "color-primary-blue"
  }, [_vm._v("Network Connect")]), _c('RouterLink', {
    class: _vm.$style.newReferralButtonMobile,
    attrs: {
      "to": {
        name: 'network-connect-new-referral'
      }
    }
  }, [_c('BaseButton', {
    attrs: {
      "options": {
        defaultPadding: true
      }
    }
  }, [_vm._v("Create Referral")])], 1)], 1), _vm.isBoOrOpsManager ? _c('div', {
    class: _vm.$style.referralTypeToggleContainer
  }, [_c('BaseSelector', {
    staticClass: "mr-15",
    attrs: {
      "active": _vm.referralType === 'Users'
    },
    on: {
      "click": function click($event) {
        return _vm.pickReferralType('Users');
      }
    }
  }, [_vm._v(" Individual ")]), _c('BaseSelector', {
    attrs: {
      "active": _vm.referralType === 'Offices'
    },
    on: {
      "click": function click($event) {
        return _vm.pickReferralType('Offices');
      }
    }
  }, [_vm._v("Office")])], 1) : _vm._e(), _c('TabContainer', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_vm.referralCategory === 'received' && !_vm.isUserLO ? [_c('p', {
          staticClass: "text-center color-dark-gray"
        }, [_vm._v("You must be a licensed MLO to receive referrals here.")])] : [!_vm.tableData.length ? _c('p', {
          staticClass: "text-center color-dark-gray"
        }, [_vm._v("No referrals found")]) : _vm._e(), _vm.tableDataActive.length ? _c('h2', {
          staticClass: "mt-2"
        }, [_vm._v("Active Referrals")]) : _vm._e(), _c('ReferralsTable', {
          attrs: {
            "table-data": _vm.tableDataActive,
            "table-fields": _vm.tableFields
          }
        }), _vm.tableDataInactive.length ? _c('h2', {
          staticClass: "mt-2"
        }, [_vm._v("Inactive Referrals")]) : _vm._e(), _c('ReferralsTable', {
          attrs: {
            "table-data": _vm.tableDataInactive,
            "table-fields": _vm.tableFields
          }
        })]];
      },
      proxy: true
    }])
  }, [_c('b-nav', {
    staticClass: "motto-tabs mt-4",
    attrs: {
      "tabs": ""
    }
  }, [_c('b-nav-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMobile || _vm.referralType !== 'Offices',
      expression: "!isMobile || referralType !== 'Offices'"
    }],
    attrs: {
      "active": _vm.referralCategory === 'received'
    },
    on: {
      "click": function click($event) {
        _vm.referralCategory = 'received';
      }
    }
  }, [_vm._v(" Received ")]), _c('b-nav-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMobile || _vm.referralType !== 'Offices',
      expression: "!isMobile || referralType !== 'Offices'"
    }],
    attrs: {
      "active": _vm.referralCategory === 'sent'
    },
    on: {
      "click": function click($event) {
        _vm.referralCategory = 'sent';
      }
    }
  }, [_vm._v(" Sent ")]), _vm.isBoOrOpsManager ? _c('b-nav-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMobile || _vm.referralType !== 'Users',
      expression: "!isMobile || referralType !== 'Users'"
    }],
    attrs: {
      "active": _vm.referralCategory === 'office_received'
    },
    on: {
      "click": function click($event) {
        _vm.referralCategory = 'office_received';
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.primaryOfficeTradeName) + " - Received ")]) : _vm._e(), _vm.isBoOrOpsManager ? _c('b-nav-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMobile || _vm.referralType !== 'Users',
      expression: "!isMobile || referralType !== 'Users'"
    }],
    attrs: {
      "active": _vm.referralCategory === 'office_sent'
    },
    on: {
      "click": function click($event) {
        _vm.referralCategory = 'office_sent';
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.primaryOfficeTradeName) + " - Sent ")]) : _vm._e(), _c('RouterLink', {
    class: _vm.$style.newReferralButton,
    attrs: {
      "to": {
        name: 'network-connect-new-referral'
      }
    }
  }, [_c('BaseButton', {
    attrs: {
      "options": {
        defaultPadding: true
      }
    }
  }, [_vm._v("Create Referral")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }